import { Box } from '@factorialco/deprecated-design-system'
import { WorkingConditionVersionApplicationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import CustomCallout from './CustomCallout'

interface Props {
  workingConditionVersionApplication: WorkingConditionVersionApplicationFragment
}

const WorkingConditions = ({ workingConditionVersionApplication }: Props) => (
  <Box gap="s16" flexDirection="column" alignItems="flexStart">
    <CustomCallout
      description={i18n.t('contract_versions.header.tags.working_conditions.updated_by', {
        workingCondition: workingConditionVersionApplication.version.name,
      })}
      type="link"
    />
    {workingConditionVersionApplication.differentFieldsCount > 0 && (
      <CustomCallout
        description={i18n.tp(
          'contract_versions.header.tags.working_conditions.detached_attributes',
          {
            count: workingConditionVersionApplication.differentFieldsCount,
            workingCondition: workingConditionVersionApplication.version.name,
          }
        )}
        type="unlink"
      />
    )}
  </Box>
)

export default WorkingConditions
